import { Stack, Typography } from '@mui/material';
import { IconGripVertical } from '@tabler/icons';
import CopyIcon from 'assets/icons/form-builder/forms/steps/copy.svg';
import DeleteIcon from 'assets/icons/form-builder/forms/steps/delete.svg';
import EditIcon from 'assets/icons/form-builder/forms/steps/edit.svg';
import { FormattedMessage } from 'react-intl';

const Step = ({ currentStep, index, handleCopy, handleEdit, handleDelete }) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" p={2} sx={{ cursor: 'pointer' }}>
      <Stack direction="row" alignItems="center" gap={2}>
        <IconGripVertical />
        <Stack>
          <Typography sx={{ fontSize: 16, color: '#727272' }}>
            <FormattedMessage defaultMessage="Step" /> {index + 1}
          </Typography>{' '}
          <Typography sx={{ fontSize: 18, color: '#393939', fontWeight: 500 }}>{currentStep?.title}</Typography>
        </Stack>
      </Stack>

      <Stack direction="row" gap={2}>
        <img src={CopyIcon} alt="copy" onClick={() => handleCopy(index)} />
        <img src={EditIcon} alt="edit" onClick={() => handleEdit(index)} />
        <img src={DeleteIcon} alt="delete" onClick={() => handleDelete(index)} />
      </Stack>
    </Stack>
  );
};

export default Step;
